import { RevoteConfirmModal } from './RevoteConfirmModal';

export function RevoteConfirmModalProvider() {
  return <RevoteConfirmModal />;
}
